import { render, staticRenderFns } from "./phone-register.vue?vue&type=template&id=78f69812&"
import script from "@/model/phoneregister.js?vue&type=script&lang=js&"
export * from "@/model/phoneregister.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports